import { Afspraak } from '@ha/domain';

import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AppointmentResource {
    private readonly httpClient = inject(HttpClient);
    private readonly apiUrl: string = '/services/gw-apix-rs-hypotheken-afspraak/api/afspraken';
    private readonly xApiKeyHeader = 'X-Api-Key';
    private readonly xApiKey: string = '{<BSPX-RS-HYPOTHEKENAFSPRAAK-API-KEY>}';

    sendRequest(afspraak: Afspraak): Observable<HttpResponse<any>> {
        return this.httpClient.post<void>(this.apiUrl, afspraak, {
            observe: 'response',
            headers: new HttpHeaders().set(this.xApiKeyHeader, this.xApiKey)
        });
    }
}
